import { Chart } from '@frontend/chart/types';

export const PUDO_TRANSACTION_VOLUME_BY_SPOT_DONUT_CHART_MOCK_DATA: Chart = {
    series: [
        {
            name: 'SPOT-A',
            data: [{ label: 'full_period', value: 128 }]
        },
        {
            name: 'SPOT-B',
            data: [{ label: 'full_period', value: 94 }]
        },
        {
            name: 'SPOT-C',
            data: [{ label: 'full_period', value: 67 }]
        },
        {
            name: 'SPOT-D',
            data: [{ label: 'full_period', value: 41 }]
        },
        {
            name: 'SPOT-E',
            data: [{ label: 'full_period', value: 22 }]
        }
    ]
};
